import styled from 'styled-components';

// CONSTANTS
import { WHITE } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';
import { getS3ImageUrl } from '@/utility/content';

const heroBg = getS3ImageUrl('/partner-home/partner-hero-bg.jpg');

export const Container = styled.section`
  padding: 80px 0 60px;
  background: url(${heroBg}) no-repeat center center;
  background-size: cover;

  .info {
    position: relative;
    height: 100%;
    padding: 30px;
    border-radius: 16px;
    background-color: ${p => p.theme.palette.home.left};
    color: ${p => p.theme.palette.home.leftText};
    max-width: 540px;
    width: 100%;
    z-index: 2;

    ${breakpoints.down('md')} {
      max-width: none;
    }

    ${breakpoints.down('xs')} {
      max-width: none;
    }

    &__icon {
      font-size: 4.4rem;
      display: inline-block;
    }
  }

  .search {
    &__input {
      .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] {
        padding-top: 10px;
        padding-bottom: 10px;
      }
    }

    .MuiInputBase-root {
      background-color: ${WHITE};
    }
  }
`;

export default Container;
